export default __webpack_public_path__ + "static/media/about (1800).5e61d13d.png";